import { render } from "./squeezePlay.vue?vue&type=template&id=42f27de4"
import script from "./squeezePlay.vue?vue&type=script&lang=js"
export * from "./squeezePlay.vue?vue&type=script&lang=js"

import "./squeezePlay.vue?vue&type=style&index=0&id=42f27de4&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__